
// ============================================================================
// Enums
// ============================================================================
export enum Gender {
  Male = 1,
  Female = 2,
  Others = 3,
}

export enum Role {
  Viewer = 0,
  Teacher = 1,
  Editor = 2,
  Admin = 3,
}

export enum StudentStatus {
  Active = 0,
  Inactive = 1,
  Suspended = 2,
  Expelled = 3,
  Graduated = 4,
  ToBePromoted = 5,
  ToBeGraduated = 6,
}

export enum PromotionStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Promoted = "Promoted",
  Failed = "Failed",
  Available = "Available",
}

export enum PromotionType {
  Automatic = "Automatic",
  Manual = "Manual",
  SessionChange = "SessionChange",
}


export enum NotificationType {
  DirectMessage = 0,
  BroadcastMessage = 1,
  SystemMessage = 2,
  DashboardUpdate = 3,
  ResultUpdate = 4,
}

export enum AuditTrailAction {
  Create = "CREATE",
  Update = "UPDATE",
  Delete = "DELETE",
  ResultEntry = "RESULT_ENTRY",
}

export enum AuditTrailEntityType {
  SummaryResultEntry = "SummaryResultEntry",
  Guardian = "Guardian",
  Student = "Student",
  User = "ApplicationUser",
  Notification = "Notification",
  PromotionRule = "PromotionRule",
  StudentPromotion = "StudentPromotion",
  StudentData = "StudentData",
}

// ============================================================================
// Finance Enums
// ============================================================================
export enum InvoiceStatus {
  Pending = 0,
  Partial = 1,
  Paid = 2,
  Overpaid = 3,
  Refunded = 4,
  Cancelled = 5,
}

export enum DiscountRuleType {
  SiblingCount = 0,
  EarlyPayment = 1,
  CustomPromo = 2,
  BulkPayment = 3,
}

export enum DiscountValueType {
  Percentage = 0,
  FixedAmount = 1,
}

export enum PaymentMethod {
  Cash = 0,
  BankTransfer = 1,
  Cheque = 2,
  VirtualAccount = 3,
  Card = 4,
}